function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.51467 8.84813L16 0.362793L24.4853 8.84813C26.1636 10.5264 27.3064 12.6646 27.7694 14.9923C28.2324 17.3201 27.9948 19.7329 27.0865 21.9256C26.1783 24.1183 24.6402 25.9924 22.6668 27.311C20.6934 28.6296 18.3734 29.3334 16 29.3334C13.6266 29.3334 11.3066 28.6296 9.33318 27.311C7.35979 25.9924 5.82172 24.1183 4.91346 21.9256C4.00521 19.7329 3.76756 17.3201 4.23057 14.9923C4.69358 12.6646 5.83646 10.5264 7.51467 8.84813Z"
});

function SvgWaterFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFill);
export default __webpack_public_path__ + "static/media/water-fill.6b2a6344.svg";
export { ForwardRef as ReactComponent };